<h4 class="f-w-700 f-s-20 m-t-24 m-b-8">{{"otp.two_step_authentication" | translate}}</h4>
<span class="f-s-14 d-block f-s-14 m-t-24">
  {{"otp.sent code otp" | translate}}
</span>
<span class="f-w-600 d-block m-t-16">{{ email | maskEmail}}</span>

<form class="m-t-30 p-t-30" [formGroup]="verifyOtpForm" (ngSubmit)="onSubmit()">
  <mat-label class="f-s-14 f-w-600 m-b-12 d-block">
    {{"otp.type_security_code" | translate}}
  </mat-label>
  <div class="d-flex align-items-center"></div>
  <div class="row custom-row">
    <ng-container formArrayName="otp">
      <div class="col-2" *ngFor="let control of otpControls; let i = index">
        <mat-form-field appearance="outline" class="w-100" color="primary">
          <input
            matInput
            [formControlName]="i"
            minlength="1"
            maxlength="1"
            class="otp-inputbar input-otp-code"
            (input)="onInputChange(i, $event)"
            (keydown)="onKeyDown(i, $event)"
            #otpInput
          />
        </mat-form-field>
      </div>
    </ng-container>
  </div>
  <mat-error *ngIf="verifyOtpForm.controls['otp'].invalid && verifyOtpForm.touched">
    {{ 'otp.all_codes_required' | translate }}
  </mat-error>

  <button type="submit" [disabled]="verifyOtpForm.invalid" mat-flat-button color="primary" class="w-100">
    {{"otp.verify_account" | translate}}
  </button>
</form>
<span class="d-block f-w-500 d-block f-s-14 m-t-24">{{"otp.not_code" | translate}}
  <a href="javascript:void(0)" (click)="resendOtp()" class="text-decoration-none text-primary f-w-500">
    {{"otp.resend" | translate}}
  </a>
</span>
